<script setup lang="ts">
import {
  AlertDialog, AlertDialogCancel,
  AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle,
} from '@kyoto2/components/ui/alert-dialog'
import { Button } from '@kyoto2/components/ui/button'

withDefaults(defineProps<{
  open: boolean
  title?: string
  description?: string
  confirmLabel?: string
  destructive?: boolean
}>(), {
  title: 'Are you sure?',
  description: 'This action cannot be undone.',
  confirmLabel: 'Confirm',
  destructive: false,
})

const emit = defineEmits<{
  'update:open': [value: boolean]
  confirm: []
}>()

function onConfirm() {
  emit('confirm')
  emit('update:open', false)
}
</script>

<template>
  <AlertDialog :open="open" @update:open="$emit('update:open', $event)">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{{ title }}</AlertDialogTitle>
        <AlertDialogDescription>{{ description }}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel @click="$emit('update:open', false)">Cancel</AlertDialogCancel>
        <Button
          :variant="destructive ? 'destructive' : 'default'"
          @click="onConfirm"
        >
          {{ confirmLabel }}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
